module.exports = __webpack_public_path__ + "static/200529_IWIK Logo-02-50df23cbc525cbb65715255174d6178b.jpg";